<template>
	<div
		class='orderDetails'
		v-loading="loading"
	>
		<div class="header">
			<div class="title">
				<span
					@click="back"
					style="cursor: pointer; color: #4587ff; margin-right: 20px"
				><i class="el-icon-arrow-left"></i>返回</span>
			</div>
		</div>

		<div class="content_box">
			<div class="order_info">
				<div class="text">
					订单信息
				</div>

				<div class="info_item">
					<div class="left">产品名称：</div>
					<div class="right">
						{{ dataobj.productSubject }}
					</div>
				</div>

				<div class="info_item">
					<div class="left">产品类型：</div>
					<div class="right">
						{{ orderType(dataobj.orderType) || '' }}
					</div>
				</div>

				<div class="info_item">
					<div class="left">产品{{dataobj.orderType === 6? '字符':'价格'}}：</div>
					<div
						class="right"
						style="font-family: 600;color: red;"
					>
						{{ dataobj.orderPrice }}
					</div>
				</div>

				<div class="info_item">
					<div class="left">当前状态：</div>
					<div class="right">
						{{ dataobj.payStatus == 0 ? '订单生成':dataobj.payStatus == 1 ? '支付中':dataobj.payStatus == 2 ? '支付成功':dataobj.payStatus == 3 ? '支付失败':dataobj.payStatus == 4 ? '已撤销':dataobj.payStatus == 5 ? '已退款':dataobj.payStatus == 6 ? '订单关闭':dataobj.payStatus == 7 ? '交易成功':dataobj.payStatus == 10 ? '申请退款':dataobj.payStatus == 11 ? '退款中':dataobj.payStatus == 12 ? '退款成功':dataobj.payStatus == 13 ? '退款失败':dataobj.payStatus == 14 ? '退款任务关闭':dataobj.payStatus == 15 ? '拒绝退款':''}}
					</div>
				</div>

				<div class="info_item">
					<div class="left">支付方式：</div>
					<div class="right">
						{{ dataobj.wayCode == 'WX_LITE' ? '微信小程序':dataobj.wayCode == 'WX_JSAPI' ? '微信公众号':dataobj.wayCode == 'WX_NATIVE' ? '微信扫码':dataobj.wayCode == 'WX_H5' ? '微信H5':dataobj.wayCode == 'WX_BAR' ? '微信条码':dataobj.wayCode == 'WX_APP' ? '微信APP':dataobj.wayCode == 'ALI_WAP' ? '支付宝WAP':dataobj.wayCode == 'ALI_QR' ? '支付宝二维码':dataobj.wayCode == 'ALI_PC' ? '支付宝PC网站':dataobj.wayCode == 'ALI_APP' ? '支付宝APP':''}}
					</div>
				</div>

				<div
					class="info_item"
					v-if="dataobj.orderType !== 6"
				>
					<div class="left">交易单号：</div>
					<div class="right">{{ dataobj.payOrderId || ''}}</div>
				</div>

				<div class="info_item">
					<div class="left">商品单号：</div>
					<div class="right">{{ dataobj.orderNo}}</div>
				</div>

				<div class="info_item">
					<div class="left">下单时间：</div>
					<div class="right">{{ dataobj.createTime}}</div>
				</div>

				<div class="info_item">
					<div class="left">支付金额：</div>
					<div class="right red">{{ dataobj.payPrice || ''}}</div>
				</div>
			</div>

			<div
				class="order_info"
				v-if='(dataobj.orderType === 7 && dataobj.resultType !== 1) || dataobj.orderType === 6'
			>
				<div class="text">
					生成内容
				</div>
				<div
					class=""
					style="width: 100%;display: flex;justify-content: center;"
				>
					{{dataobj.productSubject}}
				</div>
				<span
					style="font-size: 30rpx;line-height: 50rpx;"
					user-select
				>{{dataobj.resultContent}}</span>
			</div>

			<div
				class="order_info"
				v-if="dataobj.orderType === 8"
			>
				<div class="text">
					需求信息
				</div>

				<div class="info_item">
					<div class="left">需求描述：</div>
					<div
						class="right"
						style="line-height: 1.4;"
						v-html="dataobj.writerServiceOrderDTO.content"
					>

					</div>
				</div>

				<div class="info_item">
					<div class="left">下单用户：</div>
					<div class="right">{{ dataobj.writerServiceOrderDTO.fromNickName}}</div>
				</div>
			</div>

			<div
				class="order_info"
				v-if="dataobj.orderType === 7 && dataobj.resultType === 1 && (dataobj.orderStatus === 9 || dataobj.orderStatus === 10)"
			>
				<div class="info_item">
					<div class="left">生成内容：</div>
					<div
						class="right clickText"
						style="color: #326afb;"
						@click="goStatisticsDetails()"
					>
						点击查看生成内容
					</div>
				</div>
			</div>

			<div
				class="order_info"
				v-if="dataobj.orderType === 19"
			>
				<div class="info_item">
					<div class="left">生成内容：</div>
					<div
						class="right clickText"
						style="color: #326afb;"
						@click="goPenAndink()"
					>
						点击查看生成内容
					</div>
				</div>
			</div>
			<div
				class="order_info"
				v-else-if="dataobj.url"
			>
				<div class="info_item">
					<div class="left">生成内容：</div>
					<div
						class="right clickText"
						style="color: #326afb;"
						@click="downFile(dataobj.url)"
					>
						点击查看生成内容
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { orderDetails } from "@/api/professionServer";
export default {
  name: "orderDetails",
  props: {
    orderId: {},
  },
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dataobj: {},
      loading: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    back() {
      this.$emit("back");
    },

    orderType(id) {
      if (id === 1) {
        return "批改订单";
      } else if (id === 2) {
        return "咨询培训";
      } else if (id === 6) {
        return "AIGC模型";
      } else if (id === 7) {
        return "AI成文";
      } else if (id === 8) {
        return "写手";
      } else if (id === 9) {
        return "简历";
      } else if (id === 10) {
        return "小巨人";
      } else if (id === 18) {
        return "统计分析";
      } else if (id === 19) {
        return "公文写作";
      }
    },

    async getorderDetails() {
      try {
        this.loading = true;
        const data = {
          orderId: this.orderId,
          type: 1,
        };
        let res = await orderDetails(data);
        this.loading = false;
        if (res.code != 200) return;

        this.dataobj = res.data;
      } catch (error) {
        this.loading = false;
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getorderDetails();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.orderDetails {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: #fff;
  overflow: auto;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    box-sizing: border-box;
    padding: 0 20px;
    line-height: 40px;

    .title {
      position: relative;
      font-size: 16px;
      width: 100%;
      font-family: Microsoft YaHei;
      font-weight: 600;
      color: #333333;
      .el-button {
        position: absolute;
        top: -10px;
        right: 0;
      }
    }
  }

  .content_box {
    background-color: #f8f8f8;
    box-sizing: border-box;

    .refund_shop {
      background: #ffffff;
      border-radius: 8px;
      padding: 15px 10px;

      .text {
        font-size: 15px;
        color: #ff6500;
        margin-bottom: 15px;
      }

      .content {
        display: flex;
        gap: 15px;

        .shop_info {
          font-weight: bold;
          font-size: 14px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .name {
            text {
              margin-left: 5px;
              font-size: 12px;
            }
          }

          .totalHours {
            color: #999;
            font-size: 12px;
          }

          .amount {
            color: red;
            font-size: 16px;

            text {
              font-size: 12px;
            }
          }
        }
      }
    }

    .order_info {
      margin-top: 10px;
      padding: 15px 10px;
      border-radius: 8px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      gap: 20px;
      line-height: 1.6;
      text-align: justify;
      box-sizing: border-box;

      .text {
        font-size: 15px;
      }

      .info_item {
        display: flex;
        // align-items: center;
        gap: 20px;
        font-size: 14px;

        .left {
          color: #999999;
        }

        .right {
          flex: 1;
        }
      }
    }

    .btn_box {
      position: absolute;
      width: 100%;
      padding: 10px;
      left: 0;
      bottom: 50px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn_item {
        height: 50px;
        background: #00b569;
        border: 1px solid #00b569;
        border-radius: 25px;
        text-align: center;
        line-height: 50px;
        font-size: 16px;
        width: 47%;
        color: #fff;

        &:nth-child(2) {
          background: #ffffff;
          border: 1px solid #ff6500;
          color: #ff6500;
        }
      }
    }
  }
}
</style>